import React, { useEffect, useState } from 'react';
import { Box, Circle, Flex, Text, Image, Show, CircularProgress } from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAssessmentToken } from '../../../context/AssessmentTokenContext';
import ModalTemplate from '../../common/ModalTemplate';
import ShowPracticeTestModal from '../../common/ShowPracticeTestModal';
import { useBlockItems } from '../../../hooks/V2/useCourse';
import Lottie from 'react-lottie-player';
import successLottie from '../../assets/lottie/successLottie.json';
import { useDomainConfig } from '../../../hooks/useDomainConfig';
import { SAGEX_ORG_KEY } from '../../../utils/segexOrgName';
interface Props {
	data: any;
	blockId: string;
	totalBlockItems: number;
	completedBlockItems: number;
}
const BlockItemCard = ({ completedBlockItems, totalBlockItems, data, blockId }: Props) => {
	const navigate = useNavigate();
	// get path params
	const { publishedItemId } = useParams<{ publishedItemId: string }>();
	const { isKnowYourLevelAssessmentGiven } = useAssessmentToken();
	const [showPracticeModal, setShowPracticeModal] = useState(false);
	const { data: domainConfig } = useDomainConfig({ uiHost: window.location.host });
	const { data: blockItems, refetch: reftechBlockItems, isLoading } = useBlockItems(blockId, data?.blockItemType);

	useEffect(() => {
		if (blockId) {
			reftechBlockItems();
		}
	}, [blockId, reftechBlockItems]);

	useEffect(() => {
		if (data?.blockItemType) {
			reftechBlockItems();
		}
	}, [data?.blockItemType, reftechBlockItems]);
	const completionPercentage = (completedBlockItems / totalBlockItems) * 100;
	const isSagex = domainConfig?.key === SAGEX_ORG_KEY;
	return (
		<>
			<Flex
				cursor="pointer"
				borderRadius={'8px'}
				boxShadow="0px 1px 2px 0px rgba(0, 0, 0, 0.06), 0px 1px 3px 0px rgba(0, 0, 0, 0.10);"
				// h={'4.375rem'}
				justifyContent={'space-between'}
				alignItems={'center'}
				gap={'1rem'}
				py="6px"
				onClick={() => {
					const isKnowYourLevelAssessmentNotNeeded = domainConfig?.key === SAGEX_ORG_KEY;
					if (isKnowYourLevelAssessmentGiven || isKnowYourLevelAssessmentNotNeeded) {
						navigate(`/dashboard/published-item/${publishedItemId}/block-items?blockId=${blockId}&type=${data?.blockItemType}`);
					} else {
						// TODO: show practice modal
						setShowPracticeModal(true);
					}
				}}
			>
				<Flex gap={'0.8rem'} justifyContent={'space-between'} alignItems={'center'}>
					<Box p={'12px 8px 20px 12px'}>
						<Circle bg={data?.bgColor} size="2.36rem" p="0px">
							<Image w="full" borderRadius="100%" h="24px" src={data?.logo} alt={'trophy'} />
						</Circle>
					</Box>

					<Flex flexDirection={'column'} justifyContent="space-around" gap={'6px'}>
						<Text textStyle={'body1-md'} color={'#3B3435'}>
							{data?.name}
						</Text>

						{!isSagex && (
							<Flex justifyContent={'center'} alignItems="center" gap={'6px'}>
								<Text display={'inline'} textStyle={'body2'} fontSize="12px" fontStyle="normal" fontWeight="400" lineHeight="24px" color={'#848081'}>
									{data?.companyLine}
									<Image h="20px" mb="-6px" ml="4px" display={'inline'} src={data?.companyLogo} alt={'flipkart'} />
								</Text>
								{/* <Image h="20px" mb="-6px" display={'inline'} src={data?.companyLogo} alt={'flipkart'} /> */}
							</Flex>
						)}
					</Flex>
				</Flex>

				{completedBlockItems ? (
					<Box pr="16px">
						{/* {completedBlockItems}/{totalBlockItems} */}
						{completionPercentage === 100 ? (
							<Box w="32px" mx="auto" p={''}>
								<Lottie loop animationData={successLottie} play style={{ width: '100%' }} />
							</Box>
						) : (
							<CircularProgress value={(completedBlockItems / totalBlockItems) * 100} size="24px" />
						)}
					</Box>
				) : (
					<Flex justifyContent="center" p={'4px'}>
						<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
							<rect y="24" width="24" height="24" rx="8" transform="rotate(-90 0 24)" fill="white" />
							<path d="M8 17.355L13.355 12L8 6.645L9.65667 5L16.6567 12L9.65667 19L8 17.355Z" fill="#544D4F" />
						</svg>
					</Flex>
				)}
			</Flex>
			<ModalTemplate
				title=""
				marginX={2}
				paddingY="16px"
				isOpen={showPracticeModal}
				bgColor="white"
				maxWidth="343px"
				showCloseButton={true}
				showCloseButtonIcon={true}
				modalOverlayProps={{ bg: 'rgba(1, 10, 27, 0.80)' }}
				onClose={() => setShowPracticeModal(false)}
			>
				<ShowPracticeTestModal />
			</ModalTemplate>
		</>
	);
};

export default BlockItemCard;
